import { createSingleton } from '@luna/utils';

export type FeatureConfigState = {
    config: unknown;
    configWithoutOverrides: unknown;
};
export const { set, get } = createSingleton<FeatureConfigState>();

export const setFeatureConfigSingleton = set;
export const getFeatureConfigSingleton = <T = unknown>(): T => get()?.config as T;
export const getFeatureConfigWithoutOverrides = <T = unknown>(): T =>
    get()?.configWithoutOverrides as T;
